<match-display-wrapper
    matchLabel="{{ globalL10nKeys.portLabel | vtranslate }}"
    matchCriteria="{{ matchCriteria }}"
    [matchValuesExist]="!!editable.matchValue"
>
    {{ editable.matchValue }}
</match-display-wrapper>
